
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false}!../../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-efbd897c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector?type=styles&index=0!./ScalingSquaresSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./ScalingSquaresSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-efbd897c\"}!../../../../vue-loader/lib/selector?type=template&index=0!./ScalingSquaresSpinner.vue"),
  /* scopeId */
  "data-v-efbd897c",
  /* cssModules */
  null
)
Component.options.__file = "D:\\a\\1\\s\\CutomerAppRazorPrerender\\node_modules\\epic-spinners\\src\\components\\lib\\ScalingSquaresSpinner.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ScalingSquaresSpinner.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-efbd897c", Component.options)
  } else {
    hotAPI.reload("data-v-efbd897c", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/ScalingSquaresSpinner.vue
// module id = 710
// module chunks = 0